import { useEffect, useState, type RefObject } from "react";

import { BREAKPOINTS, isFluidLayout } from "@/lib/breakpoints";

const DESIGN_WIDTH = BREAKPOINTS.designWidth;
const MAX_SCALE = BREAKPOINTS.zoomMax;

export function usePulseScale(shellRef: RefObject<HTMLElement | null>) {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const shell = shellRef.current;
    if (!shell) return;

    const resetShell = () => {
      shell.style.zoom = "";
      shell.style.transform = "";
      shell.style.width = "";
      shell.style.marginLeft = "";
      shell.style.marginRight = "";
    };

    const update = () => {
      const width = window.innerWidth;
      if (isFluidLayout(width)) {
        setScale(1);
        resetShell();
        return;
      }
      if (width <= MAX_SCALE) {
        const next = width / DESIGN_WIDTH;
        setScale(next);
        shell.style.zoom = `${next}`;
        shell.style.transform = "";
        shell.style.width = `${DESIGN_WIDTH}px`;
        shell.style.marginLeft = "auto";
        shell.style.marginRight = "auto";
      } else {
        setScale(1);
        resetShell();
      }
    };

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [shellRef]);

  return scale;
}
